export default __webpack_public_path__ + "static/media/010-toast.9290b932.svg";